import { Dispatch, SetStateAction } from "react";
import { Stack } from "@mui/material";
import { JsonTagSelector } from "../../../../../../components/TagManagement/JsonTagSelector";
import { ProductFormType } from "../../../ProductForm.types";
import { ControllerRenderProps } from "react-hook-form";
import { ProductFormData } from "../ProductInformation";

interface ProductTagFieldProps {
    product: ProductFormType;
    setProduct: Dispatch<SetStateAction<ProductFormType>>;
    field: ControllerRenderProps<ProductFormData, "tags">;
}

export const ProductTagField = ({ product, setProduct, field }: ProductTagFieldProps) => {
    const handleTagsChange = (updatedTags: Record<string, string[]>) => {
        setProduct((prevState: ProductFormType) => {
            return {
                ...prevState,
                tags: updatedTags,
            };
        });

        // Update form field for validation
        field.onChange(updatedTags);
    };

    const existingTags = product.tags;
    return (
        <Stack gap={1}>
            <JsonTagSelector
                entity={{
                    id: product.id || "new",
                    tags: product.tags || {},
                }}
                entityClass="App\Entity\Product"
                context="product"
                onTagsChange={handleTagsChange}
                existingTags={existingTags}
                hideTitle
            />
        </Stack>
    );
};

export default ProductTagField;
